import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";


const ShipmentPodPrint = ({ orderDetail: shipment, deliveryDetail }) => {
  const shipmentDetails = shipment?.ShipmentDetail;

  // Determine sender: use customerId if available, else vendor
  const sender = shipmentDetails?.customerId
    ? {
      name: shipmentDetails?.customerId?.customerUser?.name || "",
      phone: shipmentDetails?.customerId?.customerUser?.phone || "",
      address: shipmentDetails?.customerId?.address || "",
    }
    : {
      name: shipmentDetails?.vendor?.shopName || "",
      phone: shipmentDetails?.vendor?.phone || "",
      address: shipmentDetails?.vendor?.address || "",
    };

  const podData = {
    shipmentId: shipmentDetails?.shipmentId,

    customer: {
      name: shipmentDetails?.vendor?.shopName,
    },
    sender: {
      name: sender?.name,
      address: sender?.address,
      phone: sender?.phone,
    },
    receiver: {
      name: shipmentDetails?.receiver?.customerUser?.name || "",
      address: shipmentDetails?.receiver?.address || "",
      phone: shipmentDetails?.receiver?.phone || "",
    },
    from: shipmentDetails?.sourceBranch?.name,
    to: shipmentDetails?.destinationBranch?.name,
    weight: shipmentDetails?.weight
      ? `${shipmentDetails.weight} Kg`
      : shipmentDetails?.unit?.value && shipmentDetails?.unit?.unitType?.name
        ? shipmentDetails.unit.unitType.name.toLowerCase() === "weight"
          ? `${shipmentDetails.unit.value} Kg`
          : `${shipmentDetails.unit.value} ${shipmentDetails.unit.unitType.name}`
        : "N/A",
    createdDate: shipmentDetails?.createdAt,

    printTime: new Date().toLocaleString("en-US", {
      dateStyle: "medium",
      timeStyle: "medium",
    }),
  };

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        width: "210mm",
        height: "297mm",
        boxSizing: "border-box",
        background: "white",
        margin: 0,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          border: "2px solid black",
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <div
          style={{
            padding: 16,
            borderBottom: "2px solid black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ flex: "0 0 auto", marginRight: "16px" }}>
            <img
              src={shipmentDetails?.entity?.logo?.url || "/logonew.png"}
              alt="Logo"
              style={{ height: "60px" }}
            />
          </div>
          <div>
            <div
              style={{ fontSize: 22, fontWeight: "bold", textAlign: "center" }}
            >
              Proof of Delivery
            </div>
            <div style={{ fontSize: 14, textAlign: "center", marginTop: 4 }}>
              {shipmentDetails?.entity?.displayName}
            </div>
          </div>
        </div>

        <div style={{ display: "flex", borderBottom: "1px solid #ccc" }}>
          <div style={{ flex: 1, padding: 16 }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
              Shipment Details
            </div>
            <div style={{ fontSize: 14 }}>
              <div style={{ marginBottom: 4 }}>
                <strong>Order ID:</strong> #{podData.shipmentId}
              </div>

              <div style={{ marginBottom: 4 }}>
                <strong>From Branch:</strong> {podData.from}
              </div>

              <div style={{ marginBottom: 4 }}>
                <strong>To Branch:</strong> {podData.to}
              </div>

              <div style={{ marginBottom: 4 }}>
                <strong> Order Created Date:</strong>{" "}
                {moment(podData.createdDate).format("MM/DD/YYYY")}
              </div>
            </div>
          </div>
          <div style={{ flex: 1, padding: 16, borderLeft: "1px solid #ccc" }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
              Package Information
            </div>
            <div style={{ fontSize: 14 }}>
              <div style={{ marginBottom: 4 }}>
                <strong>Weight:</strong> {podData?.weight}
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", borderBottom: "1px solid #ccc" }}>
          <div style={{ flex: 1, padding: 16 }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
              Sender Information
            </div>
            <div style={{ fontSize: 14 }}>
              <div style={{ marginBottom: 4 }}>
                <strong>Name:</strong> {podData.sender.name}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Phone:</strong> {podData?.sender?.phone}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Address:</strong> {podData?.sender?.address}
              </div>
            </div>
          </div>
          <div style={{ flex: 1, padding: 16, borderLeft: "1px solid #ccc" }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
              Receiver Information
            </div>
            <div style={{ fontSize: 14 }}>
              <div style={{ marginBottom: 4 }}>
                <strong>Name:</strong> {podData.receiver.name}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Phone:</strong> {podData.receiver.phone || ""}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Address:</strong> {podData.receiver.address}
              </div>
            </div>
          </div>
        </div>

        {shipmentDetails?.shipmentDetails.length > 0 && (
          <>
            <div style={{ padding: 16, borderBottom: "1px solid #ccc" }}>
              <div
                style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}
              >
                Item Details
              </div>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: 14,
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        border: "1px solid #ccc",
                        padding: 6,
                        textAlign: "left",
                      }}
                    >
                      #
                    </th>
                    <th
                      style={{
                        border: "1px solid #ccc",
                        padding: 6,
                        textAlign: "left",
                      }}
                    >
                      Name
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(shipmentDetails?.shipmentDetails || []).map((item, idx) => (
                    <tr key={idx}>
                      <td style={{ border: "1px solid #ccc", padding: 6 }}>
                        {idx + 1}
                      </td>
                      <td style={{ border: "1px solid #ccc", padding: 6 }}>
                        {item?.name || ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        <div style={{ padding: 16, borderBottom: "1px solid #ccc" }}>
          <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
            Receive By Information
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between", // <-- This makes children take equal space
              alignItems: "center",
              gap: 16, // Optional: adds space between the two columns
            }}
          >
            <div style={{ flex: 1 }}>
              <div>
                {deliveryDetail?.signature ? (
                  <img
                    src={deliveryDetail?.signature}
                    alt="Delivery Signature"
                    style={{
                      height: "auto",
                      width: "200px",
                      objectFit: "contain",
                      border: "1px solid #ccc",
                      background: "#fff",
                      display: "block",
                    }}
                  />
                ) : (
                  "No signature available"
                )}
              </div>
            </div>

            <div style={{ flex: 1 }}>
              <div>
                <div style={{ fontSize: 13, marginTop: 4, marginBottom: 6 }}>
                  <strong>Name:</strong>{" "}
                  {deliveryDetail?.receiveBy || podData.receiver.name}
                </div>
                <div style={{ fontSize: 13, marginBottom: 6 }}>
                  <strong>Phone:</strong>{" "}
                  {deliveryDetail?.receiverPhone || podData.receiver.phone}
                </div>

                <div style={{ fontSize: 13, marginBottom: 6 }}>
                  <strong>Received On:</strong>{" "}
                  {deliveryDetail?.actualDeliveryTime
                    ? moment(deliveryDetail?.actualDeliveryTime).format(
                      "MM/DD/YYYY hh:mm A"
                    )
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ padding: 16, borderBottom: "1px solid #ccc" }}>
          <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
            Product Details
          </div>
          <div style={{ fontSize: 13 }}>
            <div style={{ marginBottom: 6 }}>
              <strong>Product Description:</strong>{" "}
              {shipmentDetails?.productDescription || "N/A"}
            </div>
            <div style={{ marginBottom: 4 }}>
              <strong>Instruction:</strong>{" "}
              {shipmentDetails?.instruction || "N/A"}
            </div>
          </div>
        </div>

        <div
          style={{
            borderTop: "2px solid black",
            textAlign: "center",
            padding: 10,
            fontSize: 14,
            marginTop: "auto",
          }}
        >
          Thank you for choosing our logistics service.
        </div>
      </div>
      <style>
        {`
                @media print {
                    html, body, #shipping-label, #shipping-label > div {
                        width: 210mm !important;
                        height: 297mm !important;
                        min-width: 210mm !important;
                        min-height: 297mm !important;
                        max-width: 210mm !important;
                        max-height: 297mm !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        box-sizing: border-box !important;
                        background: white !important;
                    }
                    @page {
                        size: A4 portrait;
                        margin: 0;
                    }
                }
            `}
      </style>
    </div>
  );
};

export const generatePodPrint = (orderDetail, deliveryDetail) => {
  const labelWindow = window.open("", "_blank");
  labelWindow.document.write(`
        <html>
        <head>
            <title>Proof of Delivery</title>
            <style>
                @media print {
                    body * { visibility: hidden; }
                    #shipping-label, #shipping-label * { visibility: visible; }
                    #shipping-label { position: absolute; left: 0; top: 0; width: 100%; height: 100%; margin: 0; padding: 0; box-shadow: none; }
                    @page { margin: 0; size: auto; }
                }
            </style>
        </head>
        <body>
            <div id="shipping-label" style="display: flex; justify-content: center; align-items: center;"></div>
        </body>
        </html>
    `);
  labelWindow.document.close();

  setTimeout(() => {
    const qrRoot = labelWindow.document.getElementById("shipping-label");
    if (qrRoot) {
      const labelElement = document.createElement("div");
      qrRoot.appendChild(labelElement);
      ReactDOM.render(
        <ShipmentPodPrint
          orderDetail={orderDetail}
          deliveryDetail={deliveryDetail}
        />,
        labelElement
      );
    }
  }, 100);
};
